export default __webpack_public_path__ + "static/3-24609afbe494d65bc1d6a2d5c233e183.png";